import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import sendRequest from "../../dataProvider/sendRequest";
import useNotify from "../../unit/useNotify";
import React from "react";
import HmTextInput from "../../unit/HmTextInput";
import FieldShow from "../../unit/FieldShow";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import { Close } from "@mui/icons-material";
import formatCurrency from "../../unit/formatCurrency";
const AchPaymentsDetail = ({ ...props }) => {
  const record = props.record;
  if (!record) return null;
  const { successNotify, errorNotify } = useNotify();
  const [open, setOpen] = React.useState(false);
  const [achDetailData, setAchDetailData] = React.useState(null);
  const handleShowTransferDetail = () => {
    // Update the record status in the database
    console.log("=========>>>>>", props?.filterStatus);
    var reqUrl = "repayment/action/detail";
    if (/disbursement_/.test(props?.filterStatus)) {
      reqUrl = "disbursement/action/detail";
    } else if (/refund_/.test(props?.filterStatus)) {
      reqUrl = "refund/action/detail";
    } else if (/refill/.test(props?.filterStatus)) {
      reqUrl = "refill/action/detail";
    }
    //if repyament, id is payment Id, if disbursement, id is applicationId
    var parmId = record.id;
    if (
      props?.filterStatus?.includes("today") ||
      props?.filterStatus?.includes("repayment_")
    ) {
      parmId = record?.iPaymentId;
      if (parmId === undefined) {
        parmId = record?.paymentId;
      }
    }
    if (props?.filterStatus?.includes("repayment_delayedFails")) {
      parmId = record?.iSourceId;
    }

    if (props?.filterStatus?.includes("disbursement_")) {
      parmId = record?.iApplicationId;
    }
    if (props?.filterStatus?.includes("refund_")) {
      parmId = record?.iPaymentId;
    }
    if (props?.filterStatus?.includes("refill_")) {
      parmId = record?.iPaymentId;
    }

    var response = sendRequest(reqUrl, {
      id: parmId,
      data: {
        filterStatus: props?.filterStatus,
        appId: record?.iApplicationId,
      },
    });
    response
      .then((res) => {
        if (res.code == 200) {
          setAchDetailData(res.data);
          setOpen(true);
        } else {
          errorNotify("" + res.message);
        }
      })
      .catch((error) => {
        errorNotify("Error: " + error.message);
      });
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Tooltip title={`View detail`} placement="left">
        <IconButton
          size="small"
          onClick={handleShowTransferDetail}
          sx={{ marginLeft: "5px", p: 1, color: "#1976d2" }}
        >
          <ReceiptIcon />
        </IconButton>
      </Tooltip>
      {open && (
        <>
          <Dialog
            open={open}
            onClose={handleClose}
            fullWidth={true}
            maxWidth="lg"
          >
            <DialogTitle
              sx={{
                fontWeight: "bold",
                borderBottom: "1px solid #e5e5e5",
                color: "#465384",
                textTransform: "uppercase",
              }}
            >
              ACH Transfer Detail
              {/* 右侧显示关闭icon */}
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              {!achDetailData && (
                <Typography variant="body1" sx={{ mt: 2 }}>
                  {/* No ACH Transfer Detail available */}
                  No Transfer Detail available
                </Typography>
              )}
              {achDetailData && achDetailData?.offlineRefund == "yes" && (
                <>
                  <Box
                    sx={{
                      width: "100%",
                      pt: 1,
                      pb: 2,
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        borderBottom: 1,
                        borderColor: "divider",
                        marginTop: 2,
                        marginBottom: 1,
                        ".MuiCardContent": { paddingTop: 0 },
                      }}
                    >
                      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                        Offline Refund Detail
                      </Typography>
                      <FieldShow
                        title="Transfer Date"
                        value={formatCurrency(achDetailData?.dTransferDate)}
                        fontFamily="dateFontFamily"
                      />
                      <FieldShow
                        title="Amount"
                        value={formatCurrency(achDetailData?.payOffAmount)}
                        fontFamily="numberFontFamily"
                      />
                    </Box>
                  </Box>
                </>
              )}
              {achDetailData && !achDetailData?.offlineRefund && (
                <Box
                  sx={{
                    width: "100%",
                    pt: 1,
                    pb: 2,
                    height: "50vh",
                    maxHeight: "50vh",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      borderBottom: 1,
                      borderColor: "divider",
                      marginTop: 2,
                      marginBottom: 1,
                      ".MuiCardContent": { paddingTop: 0 },
                    }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                      Sending Account
                    </Typography>
                  </Box>
                  <TextField
                    variant="outlined"
                    value={achDetailData?.sendbank || ""}
                    label="Sending Bank"
                    disabled={true}
                    InputLabelProps={{ shrink: true }}
                  />
                  <TextField
                    variant="outlined"
                    value={achDetailData?.sendaccount || ""}
                    label="Sending Account"
                    disabled={true}
                    InputLabelProps={{ shrink: true }}
                  />
                  {/* <TextField
                  variant="outlined"
                  value={achDetailData?.sendaccountid || ""}
                  label="Sending Account Id"
                  disabled={true}
                /> */}
                  <Box
                    sx={{
                      width: "100%",
                      borderBottom: 1,
                      borderColor: "divider",
                      marginTop: 2,
                      marginBottom: 1,
                      ".MuiCardContent": { paddingTop: 0 },
                    }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                      Receiving Account
                    </Typography>
                  </Box>
                  <TextField
                    variant="outlined"
                    value={achDetailData?.receivingbank || ""}
                    label="Receiving Bank"
                    disabled={true}
                    InputLabelProps={{ shrink: true }}
                  />
                  <TextField
                    variant="outlined"
                    value={achDetailData?.receivingaccount || ""}
                    label="Receiving Account"
                    disabled={true}
                    InputLabelProps={{ shrink: true }}
                  />

                  {(achDetailData?.sCorrelationId || record?.sErrorMsg) && (
                    <>
                      <Box
                        sx={{
                          width: "100%",
                          borderBottom: 1,
                          borderColor: "divider",
                          marginTop: 2,
                          marginBottom: 2,
                          ".MuiCardContent": { paddingTop: 0 },
                        }}
                      >
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                          Transfer
                        </Typography>
                      </Box>
                      {achDetailData?.sCorrelationId && (
                        <FieldShow
                          title="Correlation ID"
                          value={
                            achDetailData ? achDetailData?.sCorrelationId : ""
                          }
                        />
                      )}
                      {record?.sErrorMsg && (
                        <>
                          <FieldShow
                            title="Error Code"
                            value={record ? record?.sErrorMsg : ""}
                          />
                          <FieldShow
                            title="Error Date"
                            value={record ? record?.dErrorDate : ""}
                          />
                        </>
                      )}
                    </>
                  )}

                  <Box sx={{ height: "50px" }}></Box>
                </Box>
              )}
              {/* <DialogActions>
                <CustomButtonCancel onClick={handleClose} label="Close" />
              </DialogActions> */}
            </DialogContent>
          </Dialog>
        </>
      )}
    </>
  );
};
export default AchPaymentsDetail;
